// extracted by mini-css-extract-plugin
export default {"main":"Home_main__8H7BE","home":"Home_home__PwhEJ"};